import { Link } from "react-router-dom";
import { expoIcons } from "../config/landingPageIcons";

export default function Expo({ section, items = [] }) {
  if (!section || section.is_enabled === 0) return null;

  return (
    <section className="expo section" aria-label="Expo and events">
      <div className="section__inner expo__inner">
        <div className="expo__text">
          {section.badge && <span className="section__tag">{section.badge}</span>}
          <h2 className="expo__title">{section.title}</h2>
          {section.body && <p className="expo__desc">{section.body}</p>}
          {section.secondary_body && <p className="expo__desc">{section.secondary_body}</p>}
          <div className="expo__actions">
            {section.button_text && section.button_link && (
              <Link to={section.button_link} className="btn btn--filled">{section.button_text}</Link>
            )}
            {section.secondary_button_text && section.secondary_button_link && (
              <Link to={section.secondary_button_link} className="btn btn--ghost">{section.secondary_button_text}</Link>
            )}
          </div>
        </div>

        <div className="expo__highlights">
          {items.map((item) => (
            <div key={item.id} className="expo-highlight">
              <span className="expo-highlight__icon" aria-hidden="true">{expoIcons[item.extra?.icon] || expoIcons.schools}</span>
              <strong className="expo-highlight__label">{item.title}</strong>
              <p className="expo-highlight__desc">{item.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
